import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AclToolsService } from '../acl/tools/acl-tools.service';
import { AclResource } from '../acl/tools/decorators/acl-resource';

export const ACL_RESOURCES = {
  GET_ADVERTISERS: 'advGetAdvertiser',
  MANAGE_ADVERTISERS: 'advManagement',
  GET_STATISTICS_SUMMARIZE: 'statsAdvManagement',
};

@Injectable({
  providedIn: 'root',
})
export class AdvertiserAclService {
  @AclResource(ACL_RESOURCES.GET_ADVERTISERS)
  public readonly canSeeAdvertisers$: Observable<boolean>;

  @AclResource(ACL_RESOURCES.MANAGE_ADVERTISERS)
  public readonly canManageAdvertisers$: Observable<boolean>;

  @AclResource(ACL_RESOURCES.GET_STATISTICS_SUMMARIZE)
  public readonly canSeeStatisticsSummarize$: Observable<boolean>;

  public readonly aclTools: AclToolsService;

  constructor() {
    this.aclTools = inject(AclToolsService);
  }
}
